import { render, staticRenderFns } from "./Fotos.vue?vue&type=template&id=35f4f8ab&"
import script from "./Fotos.vue?vue&type=script&lang=js&"
export * from "./Fotos.vue?vue&type=script&lang=js&"
import style0 from "./Fotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports